/**
 * Human-readable descriptions for Cash Out ledger rows (member dashboard).
 */
export function explainCashOutLedgerRow(row, context = {}) {
  const { userEmailByUid = {}, programId } = context;
  const amt = Number(row.amount) || 0;
  const level = row.level != null ? `Level ${row.level}` : "";
  const filler =
    row.fillerUserId
      ? userEmailByUid[row.fillerUserId] || row.fillerUserId
      : "another member";
  const ref = row.reference ? ` · Ref: ${row.reference}` : "";

  switch (row.transactionType) {
    case "CASH_OUT_EARNINGS":
      return {
        title: `Matrix earnings · ₹${amt} · ${level}`,
        detail: `Downline fill (payment 1 of 3) from ${filler} → Cash Out Box.${ref}`,
      };
    case "LEVEL_UPGRADE":
      return {
        title: `Upgrade pool · ₹${amt} · ${level}`,
        detail: `Downline fill (payment 2 or 3 of 3) from ${filler} → reserved for next level.${ref}`,
      };
    case "LEVEL_ACTIVATED":
      return {
        title: `Level activated · ₹${amt}`,
        detail: `Upgrade pool used to open the next matrix level on ${programId || row.programId || "your COP"}.${ref}`,
      };
    case "CASH_WALLET":
      return {
        title: `Step 4 cash wallet · ₹${amt} · ${level}`,
        detail: `Matrix fill at final level from ${filler} → withdrawable cash wallet (move to Cash Wallet).${ref}`,
      };
    case "MAIN_AFP_POINTS":
      return {
        title: `Main Auto Fill points · ₹${amt} · ${level}`,
        detail: `Step 4 split from ${filler} → your main Auto Fill CO Points wallet.${ref}`,
      };
    case "REWARDS_RETIREMENT":
      return {
        title: `Rewards & Retirement · ₹${amt}`,
        detail: `Platform system wallet (enrollment or Step 4 leg).${ref}`,
      };
    case "TRANSFER_TO_ROYALTY":
      return {
        title: `Moved to Cash Wallet · ₹${amt}`,
        detail: "Transferred from Cashback earnings to your Cash Wallet balance for payout.",
      };
    case "PROGRAM_ENROLLED":
      return {
        title: `Program enrolled · ₹${amt}`,
        detail: `Cart checkout COP fee — ₹${row.metadata?.matrixLegAmount || 150} matrix leg + ₹${row.metadata?.rewardsRetirementAmount || 150} Rewards & Retirement.${ref}`,
      };
    default:
      return {
        title: `${row.transactionType || "Transaction"} · ₹${amt}${level ? ` · ${level}` : ""}`,
        detail: `${row.fromWallet || "?"} → ${row.toWallet || "?"}${ref}`,
      };
  }
}
